const DEFAULTS = {
    enabled: true
};
export let defaultOptions = DEFAULTS;
export const setDefaults = (options) => {
    defaultOptions = Object.assign(Object.assign({}, DEFAULTS), options);
};
